import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const FAQS: FAQItem[] = [{
  question: '¿Cómo recibo el libro?',
  answer: 'El acceso es inmediato. Una vez realizado el pago, recibirás un correo electrónico con el enlace de descarga. Podrás leerlo en tu celular, tablet o computadora.'
}, {
  question: '¿Es un libro físico?',
  answer: 'No, es un libro digital (ebook) en formato PDF. Esto te permite tenerlo siempre contigo y leerlo en el momento exacto que lo necesites, sin esperar envíos.'
}, {
  question: '¿Es seguro pagar con tarjeta?',
  answer: 'Totalmente. Usamos Hotmart, la plataforma de productos digitales más grande y segura de Latinoamérica. Tus datos están 100% protegidos.'
}, {
  question: '¿Qué pasa si no me gusta?',
  answer: 'Tienes una garantía incondicional de 7 días. Si sientes que el libro no es para ti, te devolvemos el 100% de tu dinero sin hacer preguntas.'
}, {
  question: '¿Necesito saber mucho de la Biblia?',
  answer: 'Para nada. Este libro está diseñado justamente para guiarte de forma simple y clara, sin importar cuánto conozcas de la Biblia.'
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto space-y-4" data-id="element-19">
      {FAQS.map((faq, index) => <div key={index} className="bg-white rounded-lg border border-amber-100 overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-20">
          <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-21">
            <span className="font-serif font-semibold text-lg text-gray-800" data-id="element-22">
              {faq.question}
            </span>
            {openIndex === index ? <ChevronUp className="w-5 h-5 text-amber-600" data-id="element-23" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-24" />}
          </button>

          <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-25">
            <p className="text-gray-600 leading-relaxed" data-id="element-26">{faq.answer}</p>
          </div>
        </div>)}
    </div>;
}